// src/features/members/MembersListContainer.tsx
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
    fetchMembers,
    selectAllMembers,
    selectMembersStatus,
    selectMembersError,
} from '@/features/members/membersSlice';
import { MembersList } from '@/components/Members';

export const MembersListContainer: React.FC = () => {
    const dispatch = useAppDispatch();
    const members = useAppSelector(selectAllMembers);
    const status  = useAppSelector(selectMembersStatus);
    const error   = useAppSelector(selectMembersError);

    useEffect(() => {
        if (status === 'idle') void dispatch(fetchMembers());
    }, [status, dispatch]);

    return (
        <MembersList
            members={members}
            loading={status === 'loading'}
            error={error}
        />
    );
};
